import axios from '@/src/api/axios_init'

export const getIsCostEnabled = async (companyId: number | undefined) => {
  const endpoint = `/companies/${companyId}/cost/status`
  const result = await axios.get(endpoint)
  const { data } = result

  return data.isCostEnabled
}
